import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import Media from 'react-bootstrap/Media';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

const renderTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    {props}
  </Tooltip>
);


function Cardto(props){



    return(



              <Col xs="12" lg="4">
              <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip("Cliquez pour afficher le contenue")}>
              <Link to={props.linkto}>
              <Card className="mb-3 shadow-lg" style={{background: props.color1}}>
                <Card.Body>
                  <Card.Title style={{color:"black"}}>{props.title}</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">{props.ty}</Card.Subtitle>
                  <Card.Text>
                    {props.content}
                  </Card.Text>
                  <Card.Link >
                    Voire
                  </Card.Link>
                  <Card.Link >{new Date().getMonth()+1}/{new Date().getFullYear()}</Card.Link>
                </Card.Body>
              </Card>
              </Link>
              </OverlayTrigger>
              </Col>
    );
}

export default Cardto;
